import { FC, useMemo } from 'react'
import styles from 'components/features/future/FutureMarriedInput/FutureMarriedInput.styl'
import { RadioButton } from 'components/atoms/inputs/RadioButton/RadioButton'
import { FutureAssumptions } from 'components/features/future/types'
import { UseFormRegister } from 'react-hook-form'

const DEFAULT_OPTIONS: string[] = ['single', 'married']

export type FutureMarriedInputProps = {
  register: UseFormRegister<FutureAssumptions>
  name: string
  options?: string[]
}

export const FutureMarriedInput: FC<FutureMarriedInputProps> = (props) => {
  const {
    options = DEFAULT_OPTIONS,
    ...restProps
  } = props

  const optionsSet = useMemo(() => {
    return new Set(options)
  }, [options])

  return (
    <div className={ styles.futureMarriedInput }>
      { optionsSet.has('single') && (
        <div className={ styles.item }>
          <RadioButton { ...restProps } label='Single' value='single' />
        </div>
      )}
      { optionsSet.has('married') && (
        <div className={ styles.item }>
          <RadioButton { ...restProps } label='Married' value='married' />
        </div>
      )}
    </div>
  )
}
